import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { Plus, Minus, ChevronDown, ChevronUp } from "lucide-react";

const INITIAL_VISIBLE = 5;

const faqCategories = [
  {
    questions: [
      {
        question: "What is corporate structuring, and why is it important for businesses in Saudi Arabia?",
        answer: "Corporate structuring involves organizing a company's operations, assets, and ownership in a way that maximizes efficiency, reduces risks, and enhances profitability. In KSA, it's crucial due to regulatory compliance and maximizing operational effectiveness."
      },
      {
        question: "What types of corporate structures are available in Saudi Arabia?",
        answer: "Common structures include Limited Liability Companies (LLCs), Joint Stock Companies, Branches of Foreign Companies, and more. Each structure has its unique characteristics in terms of ownership, liability, and governance."
      },
      {
        question: "Where can I register my company in Saudi Arabia?",
        answer: "You can register your company in Saudi Arabia through the Saudi Arabian General Investment Authority (SAGIA), which acts as the primary government agency overseeing foreign investment and business registration."
      },
      {
        question: "How to register a foreign company in Saudi Arabia?",
        answer: "To register a foreign company in Saudi Arabia, initiate the process with the Saudi Arabian General Investment Authority (SAGIA) now called MISA. Complete necessary documentation, obtain required licenses, and adhere to legal procedures which are given in detail"
      },
      {
        question: "What does mediation do to resolve disputes?",
        answer: "Mediation resolves disputes by facilitating communication, encouraging negotiation, and assisting parties in reaching mutually acceptable agreements. It empowers parties to maintain control over the outcome while preserving relationships and minimizing costs and time."
      },
      {
        question: "What are the best cases for mediation?",
        answer: "Mediation is most suitable for cases involving interpersonal conflicts, family disputes, workplace disagreements, civil matters, commercial disputes, and cases where parties seek a collaborative, confidential, and cost-effective resolution outside of court."
      },
      {
        question: "What does corporate litigation involve in Saudi Arabia?",
        answer: "Corporate litigation in Saudi Arabia encompasses legal disputes faced by businesses, including contract breaches, shareholder conflicts, regulatory compliance, intellectual property disputes, and more. Fahad Al-Tamimi Law Firm adeptly navigates these challenges."
      },
      {
        question: "How does a law firm assist businesses in corporate disputes?",
        answer: "Fahad Al-Tamimi Law firm offers tailored strategies, leveraging deep industry knowledge and legal expertise to provide precise counsel and representation. We aim to resolve disputes effectively, safeguarding client interests."
      },
      {
        question: "How do you draft a legal contract?",
        answer: "Draft a legal contract by outlining terms, obligations, and conditions clearly. Ensure compliance with relevant laws, seek legal advice if needed, and use precise language."
      },
      {
        question: "What are legal drafting services?",
        answer: "Legal drafting services involve crafting legally binding documents such as contracts and agreements, ensuring accuracy, compliance, and clarity in language and terms."
      },
      {
        question: "What is corporate governance, and why is it important in Saudi Arabia?",
        answer: "Corporate governance can be defined as the system of corporate rules, practices, and procedures by which a corporate entity is directed and controlled. In Saudi Arabia, it is crucial for fostering investor confidence, ensuring transparency, and mitigating risks associated with business operations. Effective and better corporate governance promotes sustainable growth and enhances the overall business environment."
      },
      {
        question: "What are the key regulations governing corporate governance in Saudi Arabia?",
        answer: "The primary regulatory framework governing corporate governance in Saudi Arabia includes the Corporate Governance Regulations (CGR) issued by the Saudi Capital Market Authority (CMA), as well as relevant provisions in the Companies Regulations issued by the Ministry of Commerce and Investment."
      },
      {
        question: "What is the financial crime risk in Saudi Arabia?",
        answer: "The financial crime risk in Saudi Arabia encompasses various illicit activities such as money laundering, fraud, bribery, corruption, and terrorist financing, posing threats to the financial system's integrity."
      },
      {
        question: "What is the AML law in Saudi Arabia?",
        answer: "The Anti-Money Laundering (AML) law in Saudi Arabia imposes stringent regulations to combat money laundering and terrorist financing, requiring financial institutions to implement robust compliance measures and reporting mechanisms."
      },
      {
        question: "How can I incorporate in Saudi Arabia?",
        answer: "To incorporate in Saudi Arabia, you need to adhere to the legal requirements set by the Saudi Arabian General Investment Authority (SAGIA), now the Ministry of Investment of Saudi Arabia (MISA), select a business structure, obtain necessary licenses, and register with relevant authorities."
      },
      {
        question: "How can I register my small business in Saudi Arabia?",
        answer: "To register a small business in Saudi Arabia, follow the legal procedures outlined by the Saudi Arabian General Investment Authority (SAGIA), obtain required licenses, select a suitable business structure, and complete registration with relevant authorities."
      },
      {
        question: "Can a non Saudi open a company in Saudi Arabia?",
        answer: "Yes, non-Saudis can open a company in Saudi Arabia through various legal structures such as limited liability companies (LLCs) or joint stock companies, etc. as per government regulations and fulfilling the legal requirements."
      },
      {
        question: "How can corporate structuring impact a company's ability to access government incentives and support in Saudi Arabia?",
        answer: "A well-structured corporate entity in Saudi Arabia might make a company eligible for various government incentives or support programs. For example, certain industries or regions might offer tax incentives or subsidies to companies that meet specific criteria. Having the right corporate structure that complies with local regulations could be a determining factor in accessing these benefits."
      },
      {
        question: "What role does Sharia law play in corporate structuring in Saudi Arabia?",
        answer: "Sharia law, based on Islamic principles, is a fundamental part of the legal framework in Saudi Arabia. It influences various aspects of corporate structuring, such as contract law, finance, and business practices. Understanding and aligning with Sharia principles is crucial, especially in contracts and financial dealings, to ensure compliance and avoid legal issues"
      },
      {
        question: "How does corporate structuring impact the recruitment and retention of talent in Saudi Arabia?",
        answer: "The corporate structure, especially in terms of ownership, company policies, and work culture, can significantly impact talent acquisition and retention. For instance, companies with a clear and stable corporate structure may attract high-quality talent looking for job security and stability. Similarly, ownership structures, especially those complying with Saudization policies, can positively influence a company's ability to attract local talent."
      },
      {
        question: "What could be a challenge for international businesses to function within Saudi Arabia?",
        answer: "Cultural nuances, legal regulations, and adherence to Sharia law are significant challenges for international businesses in Saudi Arabia. Navigating bureaucratic procedures, understanding local customs, and complying with Saudization policies can be challenging. Additionally, keeping pace with rapidly changing business regulations and fostering effective communication amid cultural differences are continual hurdles for international companies seeking to operate successfully in the Kingdom. However, Saudi New Laws 2022 have resolved most of the above challenges."
      },
      {
        question: "Are there free zones in Saudi Arabia?",
        answer: "Yes, Saudi Arabia has established free zones, known as Special Economic Zones (SEZs), designed to attract foreign investment and promote economic growth. The zones offer tax incentives, streamlined regulations, and infrastructure to encourage business development. They aim to foster innovation, trade, and industrial activities while providing a favorable environment for both local and foreign businesses looking to operate within these designated areas."
      },
      {
        question: "What is a CR in Saudi?",
        answer: "A 'CR' in Saudi Arabia refers to the Commercial Registration, a mandatory legal requirement for companies operating in the Kingdom. It is an official document issued by the Ministry of Commerce, indicating a business's compliance with regulations and permitting commercial activities. The CR contains vital information about the business entity, including its legal structure, activities, ownership details, and allows the company to conduct commercial operations within the country."
      }
    ]
  },
];

export function Faq() {
  const [openIndex, setOpenIndex] = useState<string | null>(null);
  const [showAll, setShowAll] = useState<boolean>(false);

  const toggleFAQ = (index: string) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleShowToggle = () => {
    if (showAll) {
      // When collapsing, close any open FAQ that's in the hidden range
      setOpenIndex(null);
    }
    setShowAll(!showAll);
  };

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      {/* FAQ Content Section */}
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header (no animations) */}
          <div className="text-center mb-16">
            <h2
              className="text-[#2b2b2a] mb-4"
              style={{
                fontSize: "clamp(2.25rem, 4vw, 3.5rem)",
                fontWeight: 600,
                lineHeight: 1.2,
              }}
            >
              Frequently Asked Questions
            </h2>

            <p
              className="text-[#2b2b2a] max-w-2xl mx-auto"
              style={{ fontSize: "1.0625rem", lineHeight: 1.8 }}
            >
              Browse through our comprehensive FAQ sections organized by topic. Can't find what you're looking for? Contact our team directly.
            </p>
          </div>

          {/* FAQ Categories */}
          {faqCategories.map((category, categoryIndex) => {
            const visibleQuestions = showAll
              ? category.questions
              : category.questions.slice(0, INITIAL_VISIBLE);
            const hasMore = category.questions.length > INITIAL_VISIBLE;

            return (
              <div key={categoryIndex} className="mb-12">
                {/* Questions */}
                <div className="space-y-4">
                  {visibleQuestions.map((faq, faqIndex) => {
                    const uniqueIndex = `${categoryIndex}-${faqIndex}`;
                    const isOpen = openIndex === uniqueIndex;

                    return (
                      <div
                        key={uniqueIndex}
                        className={`border-2 rounded-xl overflow-hidden transition-all duration-300 ${
                          isOpen
                            ? 'border-[#c3a565] bg-gradient-to-br from-[#c3a565]/5 to-transparent shadow-lg'
                            : 'border-[#2b2b2a]/10 bg-white hover:border-[#c3a565]/30'
                        }`}
                      >
                        {/* Question Button */}
                        <button
                          onClick={() => toggleFAQ(uniqueIndex)}
                          className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left transition-colors cursor-pointer duration-300"
                        >
                          <span
                            className={`flex-grow transition-colors duration-300 ${
                              isOpen ? 'text-[#c3a565]' : 'text-[#2b2b2a]'
                            }`}
                            style={{
                              fontSize: "1.0625rem",
                              fontWeight: 600,
                              lineHeight: 1.5,
                            }}
                          >
                            Q. {faq.question}
                          </span>

                          <div
                            className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 ${
                              isOpen
                                ? 'bg-[#c3a565] rotate-180'
                                : 'bg-[#2b2b2a]/10 group-hover:bg-[#c3a565]/20'
                            }`}
                          >
                            {isOpen ? (
                              <Minus className="w-4 h-4 text-white" />
                            ) : (
                              <Plus className="w-4 h-4 text-[#c3a565]" />
                            )}
                          </div>
                        </button>

                        {/* Animated Answer Panel */}
                        <AnimatePresence initial={false}>
                          {isOpen && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3, ease: "easeInOut" }}
                              className="overflow-hidden"
                            >
                              <div className="px-6 pb-6 pt-2">
                                <div className="pl-4 border-l-2 border-[#c3a565]/30">
                                  <p
                                    className="text-[#2b2b2a]/70 leading-relaxed"
                                    style={{
                                      fontSize: "1rem",
                                      lineHeight: 1.8,
                                    }}
                                  >
                                    {faq.answer}
                                  </p>
                                </div>
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>
                    );
                  })}
                </div>

                {/* Show More / Show Fewer Button */}
                {hasMore && (
                  <div className="flex justify-center mt-10">
                    <button
                      onClick={handleShowToggle}
                      className="inline-flex items-center gap-2 border border-[#c3a565]/40 text-[#c3a565]   font-medium px-6 py-3 rounded-xl hover:bg-[#c3a565] hover:text-white   transition-all duration-300 text-sm tracking-wide cursor-pointer"
                      style={{ fontSize: "1rem" }}
                    >
                      {showAll ? (
                        <>
                          Show Fewer
                          <ChevronUp className="w-4 h-4" />
                        </>
                      ) : (
                        <>
                          Show More
                          <ChevronDown className="w-4 h-4" />
                        </>
                      )}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}